/* istanbul ignore file */

import { postMultpartComRetorno } from 'services/api';
import { downloadFile } from 'utils/arquivo';

export const fetchSalvarArquivos = arquivos => dispatch => {
  return new Promise((resolve, reject) => {
    const url = `Arquivo/InserirArquivos`;
    dispatch(postMultpartComRetorno(url, arquivos, false))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};

export const fetchDownloadTodosArquivos = formularioId => {
  const url = `Arquivo/DownloadFile?FormularioId=${formularioId}`;
  downloadFile(url);
};

export const fetchDownloadArquivo = documentoId => {
  const url = `Arquivo/${documentoId}`;
  downloadFile(url);
};
